const urgencyStyles = {
  low: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-700",
  medium: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700",
  high: "bg-red-50 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700"
};

const SuggestionCard = ({ suggestion }) => {
  if (!suggestion) return null;

  const urgency = (suggestion.urgency || "medium").toLowerCase();
  const urgencyClass = urgencyStyles[urgency] || urgencyStyles.medium;

  return (
    <div className="mt-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4">
      <p className="text-sm text-gray-700 dark:text-gray-200">{suggestion.summary}</p>

      <div className="mt-3 flex flex-wrap gap-2">
        <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium ${urgencyClass}`}>
          Urgency: {urgency.toUpperCase()}
        </span>
      </div>

      <div className="mt-4">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-white">Possible Conditions</h4>
        <div className="mt-2 flex flex-wrap gap-2">
          {(suggestion.possible_conditions || []).length ? (
            suggestion.possible_conditions.map((condition) => (
              <span key={condition} className="rounded-full bg-gray-100 dark:bg-gray-800 px-3 py-1 text-xs text-gray-700 dark:text-gray-200">
                {condition}
              </span>
            ))
          ) : (
            <span className="text-xs text-gray-500 dark:text-gray-400">No conditions suggested.</span>
          )}
        </div>
      </div>

      <div className="mt-4">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-white">Recommended Specialties</h4>
        <div className="mt-2 flex flex-wrap gap-2">
          {(suggestion.specialties || []).length ? (
            suggestion.specialties.map((specialty) => (
              <span key={specialty} className="rounded-full bg-green-50 dark:bg-green-900/30 px-3 py-1 text-xs text-green-700 dark:text-green-300">
                {specialty}
              </span>
            ))
          ) : (
            <span className="text-xs text-gray-500 dark:text-gray-400">No specialties suggested.</span>
          )}
        </div>
      </div>

      {!!(suggestion.precautions || []).length && (
        <div className="mt-4">
          <h4 className="text-sm font-semibold text-gray-900 dark:text-white">Precautions</h4>
          <ul className="mt-2 space-y-1 text-sm text-gray-700 dark:text-gray-300">
            {suggestion.precautions.map((item) => (
              <li key={item}>• {item}</li>
            ))}
          </ul>
        </div>
      )}

      {suggestion.advice && (
        <p className="mt-4 text-sm text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Advice:</span> {suggestion.advice}
        </p>
      )}

      <p className="mt-4 text-xs text-orange-700 dark:text-orange-300 border-t border-gray-200 dark:border-gray-700 pt-3">
        {suggestion.disclaimer || "This is not a medical diagnosis."}
      </p>
    </div>
  );
};

export default SuggestionCard;
